module.exports = __webpack_public_path__ + "img/case-lg-7.03d13d1d.jpg";